
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-ab0a0ed571";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});

parcelRegister("ff3wF", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", function () { return $b18afde638dfaf85$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $b18afde638dfaf85$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $eWkao = parcelRequire("eWkao");

var $6r1ZZ = parcelRequire("6r1ZZ");

var $ijG41 = parcelRequire("ijG41");

var $jo4dM = parcelRequire("jo4dM");

var $41Nco = parcelRequire("41Nco");

var $cWoYJ = parcelRequire("cWoYJ");

var $fqpc8 = parcelRequire("fqpc8");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $b18afde638dfaf85$var$fontFamily = (0, $41Nco.fontFamily)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $b18afde638dfaf85$var$lightH200Styles = (0, $3dJ4i.css)((0, $cWoYJ.h200)({
    theme: {
        mode: 'light'
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $b18afde638dfaf85$var$darkH200Styles = (0, $3dJ4i.css)((0, $cWoYJ.h200)({
    theme: {
        mode: 'dark'
    }
}));
var $b18afde638dfaf85$var$messageStyles = (0, $3dJ4i.css)({
    display: 'flex',
    marginTop: "var(--ds-space-050, 4px)",
    justifyContent: 'baseline',
    fontFamily: "".concat($b18afde638dfaf85$var$fontFamily),
    fontWeight: 'normal'
});
var $b18afde638dfaf85$var$messageAppearanceStyles = {
    default: (0, $3dJ4i.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $ijG41.N200), ")")
    }),
    error: (0, $3dJ4i.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $3dJ4i.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $b18afde638dfaf85$var$iconWrapperStyles = (0, $3dJ4i.css)({
    display: 'flex'
});
var $b18afde638dfaf85$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("span", {
        css: $b18afde638dfaf85$var$iconWrapperStyles
    }, children);
};
var $b18afde638dfaf85$var$messageIcons = {
    error: (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6r1ZZ))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $3dJ4i.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWkao))), {
        size: "small",
        label: "success"
    })
};
var $b18afde638dfaf85$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var _useGlobalTheme = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var icon = $b18afde638dfaf85$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : (0, $3dJ4i.jsx)("span", null, children);
    return (0, $3dJ4i.jsx)("div", {
        css: [
            mode === 'light' ? $b18afde638dfaf85$var$lightH200Styles : $b18afde638dfaf85$var$darkH200Styles,
            $b18afde638dfaf85$var$messageStyles,
            $b18afde638dfaf85$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $3dJ4i.jsx)($b18afde638dfaf85$var$IconWrapper, null, icon), content);
};
var $b18afde638dfaf85$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $b18afde638dfaf85$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $b18afde638dfaf85$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $3dJ4i.jsx)((0, $fqpc8.FieldId).Consumer, null, function(fieldId) {
        return (0, $3dJ4i.jsx)($b18afde638dfaf85$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("eWkao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae0620213e90336c$var$_react = $ae0620213e90336c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $gdjRW = parcelRequire("gdjRW");
function $ae0620213e90336c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ae0620213e90336c$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $ae0620213e90336c$var$_react.default.createElement($gdjRW.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ae0620213e90336c$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $ae0620213e90336c$var$_default = $ae0620213e90336c$var$EditorSuccessIcon;
module.exports.default = $ae0620213e90336c$var$_default;

});
parcelRegister("gdjRW", function(module, exports) {
$parcel$export(module.exports, "Icon", function () { return $bcdd45cd39ea111a$export$f04a61298a47a40f; });

var $1B83V = parcelRequire("1B83V");

var $4C7We = parcelRequire("4C7We");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jo4dM = parcelRequire("jo4dM");

var $73Trl = parcelRequire("73Trl");

var $lFtUx = parcelRequire("lFtUx");
function $bcdd45cd39ea111a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bcdd45cd39ea111a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bcdd45cd39ea111a$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $4C7We.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bcdd45cd39ea111a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $bcdd45cd39ea111a$var$iconStyles = (0, $3dJ4i.css)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $bcdd45cd39ea111a$var$_objectSpread($bcdd45cd39ea111a$var$_objectSpread({}, (0, $lFtUx.commonSVGStyles)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $bcdd45cd39ea111a$var$baseHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $bcdd45cd39ea111a$var$primaryEqualsSecondaryHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $bcdd45cd39ea111a$var$secondaryTransparentHcmStyles = (0, $3dJ4i.css)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $bcdd45cd39ea111a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $1oC0p.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $3dJ4i.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $lFtUx.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("span", (0, $1B83V.default)({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $73Trl.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $bcdd45cd39ea111a$var$iconStyles,
            $bcdd45cd39ea111a$var$baseHcmStyles,
            primaryColor === secondaryColor && $bcdd45cd39ea111a$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $bcdd45cd39ea111a$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $3dJ4i.css)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $bcdd45cd39ea111a$export$2e2bcd8739ae039 = $bcdd45cd39ea111a$export$f04a61298a47a40f;

});
parcelRegister("1B83V", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $129f802965b5856a$export$2e2bcd8739ae039; });
function $129f802965b5856a$export$2e2bcd8739ae039() {
    return $129f802965b5856a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $129f802965b5856a$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("73Trl", function(module, exports) {
$parcel$export(module.exports, "getBackground", function () { return $5243d177f8796ac4$export$18cb9425622d4e06; });
var $5243d177f8796ac4$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $5243d177f8796ac4$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
    return $5243d177f8796ac4$var$themedBackground[mode];
};

});

parcelRegister("lFtUx", function(module, exports) {
$parcel$export(module.exports, "commonSVGStyles", function () { return $fc64a0fce6a011ab$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $fc64a0fce6a011ab$export$3eb7d6130acfda37; });

var $dH0ii = parcelRequire("dH0ii");

var $3dJ4i = parcelRequire("3dJ4i");
var $fc64a0fce6a011ab$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $fc64a0fce6a011ab$var$smallStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).small);
var $fc64a0fce6a011ab$var$mediumStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).medium);
var $fc64a0fce6a011ab$var$largeStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).large);
var $fc64a0fce6a011ab$var$xlargeStyles = (0, $3dJ4i.css)((0, $dH0ii.dimensions).xlarge);
var $fc64a0fce6a011ab$export$ef0ad74202575b64 = {
    small: $fc64a0fce6a011ab$var$smallStyles,
    medium: $fc64a0fce6a011ab$var$mediumStyles,
    large: $fc64a0fce6a011ab$var$largeStyles,
    xlarge: $fc64a0fce6a011ab$var$xlargeStyles
};
var $fc64a0fce6a011ab$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $dH0ii.dimensions)[size];
    return undefined;
};

});
parcelRegister("dH0ii", function(module, exports) {
$parcel$export(module.exports, "dimensions", function () { return $9f7f84e7b3b1da86$export$62ad7b0c781000e9; });
var $9f7f84e7b3b1da86$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $9f7f84e7b3b1da86$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $9f7f84e7b3b1da86$export$62ad7b0c781000e9 = {
    small: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.small,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.medium,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.large,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.xlarge,
        height: $9f7f84e7b3b1da86$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("6r1ZZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4af6d09a4c475e32$var$_react = $4af6d09a4c475e32$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $gdjRW = parcelRequire("gdjRW");
function $4af6d09a4c475e32$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4af6d09a4c475e32$var$ErrorIcon = (props)=>/*#__PURE__*/ $4af6d09a4c475e32$var$_react.default.createElement($gdjRW.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$4af6d09a4c475e32$var$ErrorIcon.displayName = 'ErrorIcon';
var $4af6d09a4c475e32$var$_default = $4af6d09a4c475e32$var$ErrorIcon;
module.exports.default = $4af6d09a4c475e32$var$_default;

});


parcelRegister("5RBBI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $444f1300adfdb621$var$_react = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $444f1300adfdb621$var$_baseNew = $444f1300adfdb621$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $444f1300adfdb621$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $444f1300adfdb621$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $444f1300adfdb621$var$_react.default.createElement($444f1300adfdb621$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$444f1300adfdb621$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $444f1300adfdb621$var$_default = module.exports.default = $444f1300adfdb621$var$ChevronDownIcon;

});

parcelRegister("kR3EL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f2eb97fa9922fb9c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $jo4dM = parcelRequire("jo4dM");

var $cWoYJ = parcelRequire("cWoYJ");
var $f2eb97fa9922fb9c$var$formSectionDescriptionStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
var $f2eb97fa9922fb9c$var$formSectionTitleStyles = (0, $3dJ4i.css)({
    marginTop: 0,
    marginRight: "var(--ds-space-400, 32px)",
    lineHeight: "var(--ds-space-400, 32px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $f2eb97fa9922fb9c$var$formSectionWrapperStyles = (0, $3dJ4i.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$lightH600Styles = (0, $3dJ4i.css)((0, $cWoYJ.h600)({
    theme: {
        mode: 'light'
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $f2eb97fa9922fb9c$var$darkH600Styles = (0, $3dJ4i.css)((0, $cWoYJ.h600)({
    theme: {
        mode: 'dark'
    }
}));
var $f2eb97fa9922fb9c$var$FormSectionWrapper = function FormSectionWrapper(_ref) {
    var children = _ref.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionWrapperStyles
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionTitle = function FormSectionTitle(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme = (0, $jo4dM.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $3dJ4i.jsx)("h3", {
        css: [
            $f2eb97fa9922fb9c$var$formSectionTitleStyles,
            mode === 'light' ? $f2eb97fa9922fb9c$var$lightH600Styles : $f2eb97fa9922fb9c$var$darkH600Styles
        ]
    }, children);
};
var $f2eb97fa9922fb9c$var$FormSectionDescription = function FormSectionDescription(_ref3) {
    var children = _ref3.children;
    return (0, $3dJ4i.jsx)("div", {
        css: $f2eb97fa9922fb9c$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */ var $f2eb97fa9922fb9c$var$FormSection = function FormSection(_ref4) {
    var children = _ref4.children, description = _ref4.description, title = _ref4.title;
    return (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionWrapper, null, title && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionTitle, null, title), description && (0, $3dJ4i.jsx)($f2eb97fa9922fb9c$var$FormSectionDescription, null, description), children);
};
var $f2eb97fa9922fb9c$export$2e2bcd8739ae039 = $f2eb97fa9922fb9c$var$FormSection;

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $5uYpV = parcelRequire("5uYpV");

var $iOXki = parcelRequire("iOXki");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.cta',
        defaultMessage: 'Contact sales'
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.mobile.cta',
        defaultMessage: 'Contact sales'
    });
    const links = [
        {
            globalLinksKey: 'overview',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.overview',
                defaultMessage: 'Overview'
            }),
            hasSubnav: false,
            isActive: isActive === 'overview',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
        },
        {
            globalLinksKey: 'success',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.success',
                defaultMessage: 'Success'
            }),
            hasSubnav: false,
            isActive: isActive === 'success',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/success')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            isActive: isActive === 'resources',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise'),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'EnterpriseLandingPage.label',
                defaultMessage: 'Enterprise'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-enterprise',
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features'),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features')
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("hhv63", function(module, exports) {
$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $a62f11770126afae$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $a62f11770126afae$export$ef2475d0eafefa1b; });
//@ts-nocheck

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
const $a62f11770126afae$var$requiredProps = [
    'email',
    'site',
    'locale',
    'formUrl'
];
const $a62f11770126afae$var$defaultLocaleConfig = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $a62f11770126afae$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, (err)=>{
        return $a62f11770126afae$var$defaultLocaleConfig;
    });
};
const $a62f11770126afae$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : 'UNKNOWN';
    const postData = {
        locale: localeConfig.locale || paramsLocale,
        ...params
    };
    if (!$a62f11770126afae$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$a62f11770126afae$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $a62f11770126afae$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $1oC0p.useState)($a62f11770126afae$var$defaultLocaleConfig);
    (0, $1oC0p.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $a62f11770126afae$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return [
        localeConfig
    ];
};
const $a62f11770126afae$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $1oC0p.createContext)($a62f11770126afae$var$defaultLocaleConfig);
const $a62f11770126afae$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const [localeConfig] = $a62f11770126afae$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a62f11770126afae$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $a62f11770126afae$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $1oC0p.useContext)($a62f11770126afae$export$6ccd5662e539f2b6);
    if (!context) throw new Error('useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider');
    return context;
};

});

parcelRegister("7iXNu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $633ccda817580805$export$2e2bcd8739ae039; });
/* resource-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $ldrV1 = parcelRequire("ldrV1");
const $633ccda817580805$var$resourceCardStyles = {
    primary: {
        white: {
            padding: '24px',
            borderStyle: 'solid',
            borderWidth: '1px',
            borderRadius: '10px',
            // eslint-disable-next-line local/ensure-wac-token-usage
            borderColor: '#c1c7d0',
            width: '310px'
        },
        grey: {
            height: '100%',
            padding: '40px',
            // eslint-disable-next-line local/ensure-wac-token-usage
            backgroundColor: '#fafbfc',
            borderRadius: '3px'
        }
    },
    secondary: {}
};
const $633ccda817580805$var$wrapperStyle = null;
const $633ccda817580805$var$headerStyle = null;
const $633ccda817580805$var$descriptionStyle = null;
const $633ccda817580805$var$buttonStyle = null;
const $633ccda817580805$var$ResourceCard = ({ header: header, description: description, buttonText: buttonText, url: url, type: type, color: color })=>{
    const formattedType = type?.toLowerCase();
    const resourceCardType = formattedType === 'secondary' ? 'secondary' : 'primary';
    const formattedColor = color?.toLowerCase();
    const resourceCardColor = formattedColor === 'grey' ? 'grey' : 'white';
    const styles = $633ccda817580805$var$resourceCardStyles[resourceCardType][resourceCardColor];
    /* eslint-disable @typescript-eslint/no-non-null-assertion */ const { padding: padding, width: width, height: height, borderStyle: borderStyle, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, backgroundColor: backgroundColor } = styles ? styles : $633ccda817580805$var$resourceCardStyles.primary.white;
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ const backgroundStyle = null;
    const templatesTabCardDataEventProps = {
        'data-product-key': 'enterpriseContactSales',
        'data-event-component': 'linkButton',
        'data-event-container': 'cardSection',
        'data-event': 'clicked'
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _vchhusvi _1e0c1ule _1aax1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1tket94y _ect4czdy _1wyb7vkz _vwz47vkz _s7n41q9y _14b527ks"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_vchhusvi _1e0c1ule _2lx21bp4 _1yt418y6 _1bsb9tg7 _4t3imry4 _1dqo1yif _2rko1qt3 _189e1ywc _bfhkaxbu _1h6d1srq"
            ]),
            style: {
                "--_1xumd0e": (0, $6ZVlx.default)(padding),
                "--_1ea5ebz": (0, $6ZVlx.default)(width),
                "--_roksyz": (0, $6ZVlx.default)(height),
                "--_ahoyl5": (0, $6ZVlx.default)(borderStyle),
                "--_1lnby5": (0, $6ZVlx.default)(borderRadius),
                "--_g1hsiq": (0, $6ZVlx.default)(borderWidth),
                "--_1ly4823": (0, $6ZVlx.default)(backgroundColor),
                "--_37cwmb": (0, $6ZVlx.default)(borderColor)
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect418zh _1wyb1k92 _k48pbfng _1dyz165v _vwz4cjiy _s7n41q9y _syaz1bqd _qtemdlk8 _1cqs1j6v _srwzdlk8 _1bys10nf"
                    ]),
                    children: header
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect4czdy _1wyb7vkz _k48p1nn1 _vwz4bs82 _syazvwuj _s7n41q9y"
                    ]),
                    children: description
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                        text: buttonText,
                        "aria-label": buttonText,
                        url: url,
                        type: "secondary",
                        color: "whiteblue",
                        dataEventProps: templatesTabCardDataEventProps,
                        className: (0, $2jatx.default)([
                            "_bfhku67f _syazrbzz _vchhusvi _1e0c1o8l _4t3in7od _1tkel07h _85i56mu8 _bozg19bv _y4ti19bv _1q516mu8 _ect418gv _1wyboxwj _k48pbfng _vwz4nqt0 _y3gn1h6o _1hmsglyw _ajmmnqa1 _1keg1wug _3fcw1g80 _s7n41q9y _d5ymcfaq _1dqonqa1 _189et94y _80omtlke _2rko1l7b _qmxj15zi _1y1musvi _qjkj1u8q _1lrw1wug"
                        ])
                    })
                })
            ]
        })
    });
};
var $633ccda817580805$export$2e2bcd8739ae039 = $633ccda817580805$var$ResourceCard;

});


var $3NQOU = parcelRequire("3NQOU");

var $5zs0K = parcelRequire("5zs0K");
(0, $3NQOU.init)((0, $5zs0K.EnterpriseContactSalesPage));


//# sourceMappingURL=enterprise-contact-sales-page.f937d4d7.js.map
